import { iconFactory } from '../iconFactory'

export const Warning = iconFactory(
  'Warning',
  ({ fill }) => (
    <path
      d="M7.98005027,1.66666667 L0.665004194,14.3333333 L15.2950963,14.3333333 L7.98005027,1.66666667 Z M7.31504577,9.66666667 L8.64505416,9.66666667 L8.64505416,7 L7.31504577,7 L7.31504577,9.66666667 Z M7.31504577,12.3333333 L8.64505416,12.3333333 L8.64505416,10.9993333 L7.31504577,10.9993333 L7.31504577,12.3333333 Z"
      fill={fill}
      fillRule="evenodd"
    />
  ),
  { viewBox: '0 0 16 16', height: '16px', width: '16px' },
)
